<template>
  <b-modal id="user-delete-modal" title="Delete User" hide-footer @hidden="resetForm()">
    <b-alert variant="danger" :show="errors.length > 0">{{ errors[0] }}</b-alert>

    <b-alert variant="warning" show>Are you sure you want to delete this user? This action <strong>CANNOT</strong> be undone.</b-alert>
    <p class="user-details">
      <strong>Username: </strong>{{ user.username }} <br />
      <strong>Email: </strong>{{ user.email }}
    </p>

    <b-form @submit.stop.prevent="deleteUser()">
      <b-form-group label="Please type in the username to confirm." label-for="input-delete-username">
        <b-form-input v-model="form.username" type="text" id="input-delete-username" :state="validateConfirmation ? null : false"></b-form-input>
      </b-form-group>

      <div class="btn-container mt-4">
        <b-button type="submit" variant="success" class="float-right" :disabled="!validateConfirmation || deleteUserLoading">
          <div v-if="deleteUserLoading">
            <b-spinner small></b-spinner>
            <span class="ml-2">Deleting...</span>
          </div>
          <span v-else>Delete</span>
        </b-button>
        <b-button variant="danger" class="float-right mr-2" @click="closeModal()">Cancel</b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
export default {
  props: {
    user: { type: Object, required: true }
  },

  data() {
    return {
      form: {
        username: ''
      },
      deleteUserLoading: false,
      errors: []
    };
  },

  computed: {
    validateConfirmation() {
      return this.form.username === this.user.username;
    }
  },

  methods: {
    resetForm() {
      this.form = { username: '' };
    },

    closeModal() {
      this.errors = []; // Reset errors
      this.$bvModal.hide('user-delete-modal');
    },

    async deleteUser() {
      // Make sure that form data is valid
      if (!this.validateConfirmation) {
        return this.errors.push('Invalid confirmation.');
      }
      this.deleteUserLoading = true;
      this.errors = []; // Reset errors

      try {
        await this.$http.delete(`/users/${this.user.id}`);
        this.deleteUserLoading = false;
        this.closeModal();
        this.$emit('deletedUser', {
          username: this.user.username,
          email: this.user.email
        });
      } catch (err) {
        if (!err.response) {
          this.errors.push('Error: A network error occurred.');
        } else {
          if (Array.isArray(err.response.data.message)) {
            this.errors = err.response.data.message;
          } else {
            this.errors.push(err.response.data.message || 'Something went wrong while trying to delete user.');
          }
        }
        this.deleteUserLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
